export default __webpack_public_path__ + "static/media/logo.2c5a68b5.png";